import React, { Component } from 'react'
import { object, func } from 'prop-types'
import { connect } from 'react-redux'

import GlobalActions from 'store/redux/global'
import { emptyAlert } from 'utils/generators/alert'
import AlertComponent from './Alert'

@connect(
    state => ({
        alert: state.global.alert
    }),
    { dismissAlert: GlobalActions.closeAlert }
)
export class Alert extends Component {
    static propTypes = {
        alert: object,
        dismissAlert: func
    }

    render() {
        const { alert, dismissAlert } = this.props

        return <AlertComponent alert={alert || emptyAlert} dismissAlert={dismissAlert} />
    }
}



// WEBPACK FOOTER //
// src/components/Alert/index.js